var ZXT_SHOP = ((document.querySelector('meta[property="og:site_name"]') || {}).content || 'Shop');
var ZXT_ORT = (document.documentElement.getAttribute('data-shop-ort') || 'uns');
/* ============================================================
   ATELIER-WERKZEUGE
   Interaktive Bausteine fuer sections/zx-atelier-seite.liquid
   (Markup: snippets/zx-atelier-werkzeug.liquid). Jedes Werkzeug
   startet ueber [data-zxt="<typ>"] und laeuft komplett im Browser.
   ============================================================ */
(function () {
  'use strict';

  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var datumLang = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function speicher(key, wert) {
    try {
      if (wert === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      if (wert === null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(wert));
    } catch (e) { return null; }
  }

  /* ---------- Staffelpreise (Produkt "Veredelung") ---------- */
  function staffel(daten, stufe, menge) {
    var treffer = null;
    daten.forEach(function (v) {
      if (v.s !== stufe) return;
      var grenzen = v.m.split(/[–-]/).map(function (x) { return parseInt(x, 10); });
      if (menge >= grenzen[0] && menge <= (grenzen[1] || Infinity)) treffer = v;
    });
    if (!treffer) { // ueber der hoechsten Staffel: guenstigste nehmen
      daten.forEach(function (v) { if (v.s === stufe && (!treffer || v.p < treffer.p)) treffer = v; });
    }
    return treffer;
  }
  function naechsteStaffel(daten, stufe, menge) {
    var naechste = null;
    daten.forEach(function (v) {
      if (v.s !== stufe) return;
      var ab = parseInt(v.m, 10);
      if (ab > menge && (!naechste || ab < parseInt(naechste.m, 10))) naechste = v;
    });
    return naechste;
  }
  function zahl(s) { var n = parseFloat(String(s).replace(/\./g, '').replace(',', '.')); return isNaN(n) ? 0 : n; }

  /* ============================================================
     1 · STICK ODER DTF?
     ============================================================ */
  function entscheidung(root) {
    var form = $('[data-ent-form]', root), aus = $('[data-ent-ergebnis]', root);
    var texte = {
      stick: {
        titel: 'Stickerei',
        warum: 'Dein Motiv lebt von klaren Formen – gestickt wirkt es plastisch, hochwertig und hält praktisch ewig.',
        link: '/pages/stickerei'
      },
      dtf: {
        titel: 'DTF-Druck',
        warum: 'Dein Motiv braucht Details, Farbverläufe oder Fläche – im DTF-Druck bleibt alles exakt und weich.',
        link: '/pages/dtf-druck'
      }
    };
    function auswerten() {
      var s = 0, d = 0, n = 0, nur = '';
      $$('input:checked', form).forEach(function (i) {
        s += +i.dataset.s; d += +i.dataset.d; n++;
        if (i.dataset.nur) nur = nur && nur !== i.dataset.nur ? 'konflikt' : i.dataset.nur;
      });
      if (!n) return;
      var sieger = s >= d ? 'stick' : 'dtf';
      if (nur === 'stick' || nur === 'dtf') sieger = nur;
      var anteil = Math.round((sieger === 'stick' ? s : d) / Math.max(1, s + d) * 100);
      if (nur === sieger) anteil = Math.max(anteil, 90);
      var t = texte[sieger], hinweise = [];
      if (nur === 'konflikt') hinweise.push('Fotos lassen sich auf Caps, Mützen und Socken nicht drucken – wir sticken eine vereinfachte Version oder wählen ein Textil für den Druck.');
      else if (nur === 'stick') hinweise.push('Caps, Mützen und Socken veredeln wir ausschließlich mit Stickerei.');
      else if (nur === 'dtf') hinweise.push('Fotos und Illustrationen setzen wir immer im DTF-Druck um.');
      if (Math.abs(s - d) <= 2 && !nur) hinweise.push('Knapp! Beides funktioniert – oft lohnt sich die Kombi: Logo gestickt auf der Brust, großes Motiv gedruckt auf dem Rücken.');
      if (n < 4) hinweise.push('Noch ' + (4 - n) + ' Frage' + (4 - n > 1 ? 'n' : '') + ' offen – die Empfehlung wird genauer.');
      aus.innerHTML =
        '<p class="zxa__label">Unsere Empfehlung</p>' +
        '<h3 class="zxt-ent__titel">' + t.titel + '</h3>' +
        '<div class="zxt__balken" role="img" aria-label="Passung ' + anteil + ' Prozent"><i style="width:' + anteil + '%"></i></div>' +
        '<p class="zxt-ent__passt">' + anteil + ' % Passung</p>' +
        '<p>' + t.warum + '</p>' +
        hinweise.map(function (h) { return '<p class="zxt__hinweis">' + h + '</p>'; }).join('') +
        '<div class="zxa__hero-aktionen"><a class="zxa__btn zxa__btn--hell" href="' + t.link + '">Mehr zu ' + t.titel + ' →</a><a class="zxa__btn zxa__btn--glas" href="/collections">Produkt wählen</a></div>';
      aus.classList.add('is-fertig');
    }
    form.addEventListener('change', auswerten);
  }

  /* ============================================================
     2 · LOGO-CHECK (alles lokal im Browser)
     ============================================================ */
  function logoCheck(root) {
    var input = $('[data-logo-datei]', root), drop = $('[data-logo-drop]', root), aus = $('[data-logo-ergebnis]', root);
    var liste = $('[data-logo-checks]', root), fazit = $('[data-logo-fazit]', root), name = $('[data-logo-name]', root);
    var bild1 = $('[data-logo-bild]', root), bild2 = $('[data-logo-bild2]', root);
    var url = null;

    function zeile(status, titel, text) {
      return '<li class="is-' + status + '"><b aria-hidden="true">' + (status === 'gut' ? '✓' : status === 'warn' ? '!' : '✕') + '</b><span><strong>' + titel + '</strong>' + text + '</span></li>';
    }
    function zeigen(checks, text) {
      liste.innerHTML = checks.join('');
      fazit.innerHTML = text;
      aus.hidden = false;
    }
    function pruefen(datei) {
      if (!datei) return;
      if (url) URL.revokeObjectURL(url);
      var endung = (datei.name.split('.').pop() || '').toLowerCase();
      var kb = datei.size / 1024;
      name.textContent = datei.name + ' · ' + (kb > 1024 ? (kb / 1024).toFixed(1) + ' MB' : Math.round(kb) + ' KB');
      var vektor = ['svg', 'pdf', 'ai', 'eps'].indexOf(endung) > -1;
      if (vektor && endung !== 'svg') {
        bild1.removeAttribute('src'); bild2.removeAttribute('src');
        $('.zxt-logo__vorschau', root).hidden = true;
        zeigen([
          zeile('gut', 'Vektordatei', 'Perfekt – beliebig skalierbar, ideal für Stick und Druck.'),
          zeile('warn', 'Vorschau', 'Für ' + endung.toUpperCase() + ' kann der Browser keine Vorschau zeigen. Wir prüfen die Datei vor der Produktion.')
        ], 'Super Ausgangslage. Schick uns die Datei einfach mit deiner Bestellung oder Anfrage.');
        return;
      }
      $('.zxt-logo__vorschau', root).hidden = false;
      url = URL.createObjectURL(datei);
      var img = new Image();
      img.onload = function () {
        bild1.src = url; bild2.src = url;
        var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000, checks = [], punkte = 0;
        if (vektor) {
          checks.push(zeile('gut', 'Vektordatei (SVG)', 'Perfekt – beliebig skalierbar, ideal für Stick und Druck.'));
          punkte += 3;
        } else {
          var cm = (w / 300 * 2.54);
          if (w >= 2000) { checks.push(zeile('gut', w + ' × ' + h + ' px', 'Druckt scharf bis ca. ' + cm.toFixed(0) + ' cm Breite (300 dpi).')); punkte += 2; }
          else if (w >= 1000) { checks.push(zeile('warn', w + ' × ' + h + ' px', 'Reicht für Stickerei und kleine Drucke bis ca. ' + cm.toFixed(0) + ' cm. Für große Rückenmotive bitte größer.')); punkte += 1; }
          else checks.push(zeile('schlecht', w + ' × ' + h + ' px', 'Zu klein – mindestens 1000 px Breite, besser eine Vektordatei (SVG, PDF, AI).'));
        }
        // Pixel auswerten: Transparenz + Farbanzahl
        var c = document.createElement('canvas'), max = 220, f = Math.min(1, max / Math.max(w, h));
        c.width = Math.max(1, Math.round(w * f)); c.height = Math.max(1, Math.round(h * f));
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, c.width, c.height);
        var px; try { px = ctx.getImageData(0, 0, c.width, c.height).data; } catch (e) { px = null; }
        if (px) {
          var transparent = 0, eimer = {}, sichtbar = 0;
          for (var i = 0; i < px.length; i += 4) {
            if (px[i + 3] < 200) { transparent++; continue; }
            sichtbar++;
            var k = (px[i] >> 5) + ',' + (px[i + 1] >> 5) + ',' + (px[i + 2] >> 5);
            eimer[k] = (eimer[k] || 0) + 1;
          }
          var gesamt = px.length / 4;
          if (transparent / gesamt > 0.03) { checks.push(zeile('gut', 'Transparenter Hintergrund', 'Kein störender Kasten um dein Logo.')); punkte++; }
          else checks.push(zeile('warn', 'Kein transparenter Hintergrund', 'Wir stellen dein Logo frei – das klappt meist problemlos. Mit PNG ohne Hintergrund geht es schneller.'));
          var farben = Object.keys(eimer).filter(function (k) { return eimer[k] / Math.max(1, sichtbar) > 0.012; }).length;
          var feinFarben = Object.keys(eimer).length;
          if (farben <= 6 && feinFarben < 60) { checks.push(zeile('gut', 'ca. ' + farben + ' Farbe' + (farben === 1 ? '' : 'n'), 'Klare Flächen – ideal für Stickerei.')); punkte++; }
          else if (farben <= 10) checks.push(zeile('warn', 'ca. ' + farben + ' Farben', 'Für Stickerei fassen wir ähnliche Töne zusammen (bis ca. 8 Garnfarben). DTF-Druck zeigt alles.'));
          else checks.push(zeile('warn', 'Viele Farben oder Verläufe', 'Klingt nach Foto oder Verlauf – perfekt für DTF-Druck. Für Stickerei vereinfachen wir das Motiv.'));
          // Logo dunkel? -> Hinweis fuer dunkle Textilien
          var hell = 0, n = 0;
          for (var j = 0; j < px.length; j += 16) { if (px[j + 3] < 200) continue; hell += (px[j] * 0.299 + px[j + 1] * 0.587 + px[j + 2] * 0.114); n++; }
          if (n && hell / n < 60) checks.push(zeile('warn', 'Sehr dunkles Motiv', 'Auf schwarzen oder navy Textilien kaum sichtbar – siehe dunkle Vorschau. Wir können eine helle Variante sticken.'));
        }
        var warnungen = checks.filter(function (c) { return c.indexOf('is-warn') > -1; }).length;
        var text = punkte >= 3 && !warnungen ? 'Sieht top aus – deine Datei ist bereit für die Produktion.'
          : punkte >= 3 ? 'Gute Datei! Beachte die Hinweise oben – oder überlass es uns: Wir prüfen jede Datei vor der Produktion kostenlos.'
          : punkte >= 1 ? 'Funktioniert – mit den Hinweisen oben wird es noch besser. Wir prüfen jede Datei vor der Produktion kostenlos.'
            : 'Damit es schön wird, brauchen wir eine bessere Datei. Keine Sorge: Wir helfen dir – <a href="/pages/designprufung">kostenlose Designprüfung</a>.';
        zeigen(checks, text);
      };
      img.onerror = function () {
        zeigen([zeile('warn', 'Datei nicht lesbar', 'Der Browser kann diese Datei nicht anzeigen. Schick sie uns einfach – wir prüfen sie.')], '');
      };
      img.src = url;
    }
    input.addEventListener('change', function () { pruefen(input.files && input.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-ueber'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-ueber'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) pruefen(f); });
  }

  /* ============================================================
     3 · LIEFERDATUM-RECHNER (Werktage, Feiertage bundesweit + Hessen)
     ============================================================ */
  function ostern(j) { // Gauss/Meeus
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(j, monat - 1, tag);
  }
  var feiertagCache = {};
  function feiertage(j) {
    if (feiertagCache[j]) return feiertagCache[j];
    var o = ostern(j), plus = function (n) { var d = new Date(o); d.setDate(d.getDate() + n); return d; };
    var liste = [new Date(j, 0, 1), plus(-2), plus(1), new Date(j, 4, 1), plus(39), plus(50), plus(60), new Date(j, 9, 3), new Date(j, 11, 25), new Date(j, 11, 26)];
    feiertagCache[j] = liste.map(function (d) { return d.toDateString(); });
    return feiertagCache[j];
  }
  function werktag(d) { var t = d.getDay(); return t !== 0 && t !== 6 && feiertage(d.getFullYear()).indexOf(d.toDateString()) === -1; }
  function plusWerktage(start, n) { var d = new Date(start); while (n > 0) { d.setDate(d.getDate() + 1); if (werktag(d)) n--; } return d; }
  function isoDatum(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function ausIso(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }

  function lieferzeit(root) {
    var ds = root.dataset, start = $('[data-lz-start]', root), ziel = $('[data-lz-ziel]', root), aus = $('[data-lz-ergebnis]', root);
    var jetzt = new Date();
    start.value = isoDatum(jetzt); start.min = isoDatum(jetzt);
    ziel.min = isoDatum(jetzt);
    function rechnen() {
      if (!start.value) return;
      var s = ausIso(start.value), heute = isoDatum(jetzt) === start.value;
      // Starttag zaehlt nur, wenn Werktag und (bei heute) vor Annahmeschluss -> sonst ab naechstem Werktag
      var basis = new Date(s);
      if (!werktag(basis) || (heute && jetzt.getHours() >= +ds.schluss)) basis = plusWerktage(basis, 1);
      var bereitVon = plusWerktage(basis, +ds.prodMin), bereitBis = plusWerktage(basis, +ds.prodMax);
      var daVon = plusWerktage(bereitVon, +ds.versandMin), daBis = plusWerktage(bereitBis, +ds.versandMax);
      var html =
        '<ol class="zxt-lz__schritte" role="list">' +
        '<li><b>Bestellung</b><span>' + datumLang.format(s) + '</span><small>' + (basis.toDateString() !== s.toDateString() ? 'Bearbeitung ab ' + datumLang.format(basis) : 'Bearbeitung startet sofort') + '</small></li>' +
        '<li><b>Produktion</b><span>' + ds.prodMin + '–' + ds.prodMax + ' Werktage</span><small>Sticken oder drucken + Qualitätskontrolle</small></li>' +
        '<li><b>Versandbereit</b><span>' + datumLang.format(bereitVon) + ' – ' + datumLang.format(bereitBis) + '</span><small>Du bekommst eine Mail mit Sendungsnummer</small></li>' +
        '<li class="is-ziel"><b>Bei dir</b><span>' + datumLang.format(daVon) + ' – ' + datumLang.format(daBis) + '</span><small>Versand mit DHL innerhalb Deutschlands</small></li>' +
        '</ol>';
      if (ziel.value) {
        var z = ausIso(ziel.value), status, text;
        if (z >= daBis) { status = 'gut'; text = 'Passt! Bestellst du am ' + datumLang.format(s) + ', ist es rechtzeitig da.'; }
        else if (z >= daVon) { status = 'warn'; text = 'Knapp – im besten Fall klappt es. Schreib uns kurz, dann priorisieren wir deine Bestellung wenn möglich.'; }
        else { status = 'schlecht'; text = 'Das wird mit regulärer Produktion zu knapp. <a href="/pages/contact">Frag uns nach einer Express-Lösung</a> – manchmal geht mehr.'; }
        // spaetester Bestelltag
        var spaet = null, heuteNull = new Date(jetzt.toDateString());
        for (var t = new Date(z); t >= heuteNull; t.setDate(t.getDate() - 1)) {
          var b = werktag(t) ? new Date(t) : plusWerktage(t, 1);
          if (plusWerktage(plusWerktage(b, +ds.prodMax), +ds.versandMax) <= z) { spaet = new Date(t); break; }
        }
        if (spaet) text += ' Spätester Bestelltag für sicheres Ankommen: <strong>' + datumLang.format(spaet) + '</strong>' + (spaet.toDateString() === heuteNull.toDateString() ? ' (heute bis ' + ds.schluss + ' Uhr)' : '') + '.';
        html += '<p class="zxt__status is-' + status + '">' + text + '</p>';
      }
      aus.innerHTML = html;
    }
    start.addEventListener('change', rechnen); ziel.addEventListener('change', rechnen); rechnen();
  }

  /* ============================================================
     4 · PREISRECHNER
     ============================================================ */
  function preisrechner(root) {
    var daten = json($('[data-preis-daten]', root)) || [], mindest = +root.dataset.mindest || 1;
    var stufe = $('[data-preis-stufe]', root), menge = $('[data-preis-menge]', root), pos = $('[data-preis-pos]', root),
      textil = $('[data-preis-textil]', root), namen = $('[data-preis-name]', root), aus = $('[data-preis-ergebnis]', root);
    function rechnen() {
      var m = Math.max(1, parseInt(menge.value, 10) || 1), p = Math.max(1, parseInt(pos.value, 10) || 1);
      var st = staffel(daten, stufe.value, m * p); // Staffel zaehlt alle Positionen desselben Verfahrens
      if (!st) { aus.innerHTML = ''; return; }
      var ver = st.p / 100 * p, tx = zahl(textil.value), nm = 0;
      if (namen.checked) { var ns = staffel(daten, 'Namensstick', m); nm = ns ? ns.p / 100 : 0; }
      var stueck = ver + tx + nm, gesamt = stueck * m;
      var naechste = naechsteStaffel(daten, stufe.value, m * p), tipp = '';
      if (naechste) {
        var ab = parseInt(naechste.m, 10), fehlen = Math.ceil(ab / p) - m;
        if (fehlen > 0 && fehlen <= Math.max(5, m * 0.6)) tipp = '<p class="zxt__hinweis">Tipp: Mit <strong>' + fehlen + ' Teil' + (fehlen > 1 ? 'en' : '') + ' mehr</strong> rutschst du in die Staffel ab ' + ab + ' – dann kostet die Veredelung nur noch ' + euro.format(naechste.p / 100) + ' pro Position.</p>';
      }
      var warn = m < mindest ? '<p class="zxt__status is-warn">Mindestmenge: ' + mindest + ' Teile je Veredelungs-Position.</p>' : '';
      aus.innerHTML =
        '<dl class="zxt-preis__posten">' +
        '<div><dt>Veredelung (' + esc(stufe.value) + ', Staffel ' + esc(st.m) + ')</dt><dd>' + euro.format(st.p / 100) + (p > 1 ? ' × ' + p : '') + '</dd></div>' +
        (nm ? '<div><dt>Namensstick</dt><dd>' + euro.format(nm) + '</dd></div>' : '') +
        '<div><dt>Textil</dt><dd>' + euro.format(tx) + '</dd></div>' +
        '<div class="is-summe"><dt>Pro Stück</dt><dd>' + euro.format(stueck) + '</dd></div>' +
        '<div class="is-gesamt"><dt>Gesamt für ' + m + ' Teile</dt><dd>' + euro.format(gesamt) + '</dd></div>' +
        '</dl>' + tipp + warn;
    }
    [stufe, menge, pos, textil, namen].forEach(function (el) { el.addEventListener('input', rechnen); el.addEventListener('change', rechnen); });
    rechnen();
  }

  /* ============================================================
     5 · POSITIONEN & GROESSEN + Lineal in Originalgroesse
     ============================================================ */
  function positionen(root) {
    var shirt = json($('[data-pos-shirt]', root)) || [], weitere = json($('[data-pos-weitere]', root)) || [];
    var produkte = {}, reihenfolge = [];
    function dazu(produkt, eintrag) { if (!produkte[produkt]) { produkte[produkt] = []; reihenfolge.push(produkt); } produkte[produkt].push(eintrag); }
    weitere.forEach(function (p) { dazu(p.produkt, { name: p.name, maxB: p.maxB, verfahren: p.verfahren }); });
    // T-Shirt: Druck- und Stickvariante derselben Stelle zusammenfassen
    var orte = {};
    shirt.forEach(function (p) {
      var o = orte[p.id] || (orte[p.id] = { name: p.name, maxB: 0, verfahren: [] });
      o.maxB = Math.max(o.maxB, p.maxB);
      var v = p.verfahren === 'stick' ? 'Stick bis ' + p.maxB + ' cm' : 'Druck bis ' + p.maxB + ' cm';
      if (o.verfahren.indexOf(v) === -1) o.verfahren.push(v);
    });
    Object.keys(orte).forEach(function (k) { dazu('T-Shirt & Textil', { name: orte[k].name, maxB: orte[k].maxB, verfahren: orte[k].verfahren.join(' · ') }); });

    var tabs = $('[data-pos-tabs]', root), liste = $('[data-pos-liste]', root), regler = $('[data-pos-cm]', root),
      wert = $('[data-pos-cm-wert]', root), motiv = $('[data-pos-motiv]', root), vergleich = $('[data-pos-vergleich]', root);
    tabs.innerHTML = reihenfolge.map(function (p, i) { return '<button type="button" role="tab" aria-selected="' + (i === 0) + '"' + (i === 0 ? ' class="is-aktiv"' : '') + ' data-pos-produkt="' + esc(p) + '">' + esc(p) + '</button>'; }).join('');
    function zeigen(produkt) {
      $$('button', tabs).forEach(function (b) { var an = b.dataset.posProdukt === produkt; b.classList.toggle('is-aktiv', an); b.setAttribute('aria-selected', an); });
      liste.innerHTML = (produkte[produkt] || []).map(function (p) {
        return '<li><button type="button" data-pos-max="' + p.maxB + '"><strong>' + esc(p.name) + '</strong><span>' + esc(p.verfahren) + '</span><b>bis ' + String(p.maxB).replace('.', ',') + ' cm</b></button></li>';
      }).join('');
    }
    var dinge = [[2.6, 'eine 2-Euro-Münze'], [5.4, 'eine Streichholzschachtel'], [8.6, 'eine Bankkarte'], [14.8, 'eine Postkarte (kurze Seite)'], [21, 'ein DIN-A4-Blatt (kurze Seite)'], [29.7, 'ein DIN-A4-Blatt (lange Seite)']];
    function lineal() {
      var cm = parseFloat(regler.value);
      wert.textContent = String(cm).replace('.', ',') + ' cm';
      motiv.style.width = cm + 'cm';
      var naechstes = dinge.reduce(function (a, b) { return Math.abs(b[0] - cm) < Math.abs(a[0] - cm) ? b : a; });
      vergleich.textContent = Math.abs(naechstes[0] - cm) < 0.8 ? 'Etwa so breit wie ' + naechstes[1] + '.' : (cm < naechstes[0] ? 'Etwas schmaler als ' : 'Etwas breiter als ') + naechstes[1] + ' (' + String(naechstes[0]).replace('.', ',') + ' cm).';
    }
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-pos-produkt]'); if (b) zeigen(b.dataset.posProdukt); });
    liste.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pos-max]'); if (!b) return;
      $$('button', liste).forEach(function (x) { x.classList.toggle('is-aktiv', x === b); });
      regler.value = Math.min(+regler.max, +b.dataset.posMax); lineal();
    });
    regler.addEventListener('input', lineal);
    if (reihenfolge.length) zeigen(reihenfolge[0]);
    lineal();
  }

  /* ============================================================
     6 · GARNFARBE AUF TEXTIL (Kontrast nach WCAG)
     ============================================================ */
  function hexRgb(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
  function lum(h) { return hexRgb(h).map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }).reduce(function (a, v, i) { return a + v * [0.2126, 0.7152, 0.0722][i]; }, 0); }
  function kontrast(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }

  function garnKontrast(root) {
    var stoff = $('[data-garn-stoff]', root), probe = $('[data-garn-probe]', root), eingabe = $('[data-garn-eingabe]', root),
      info = $('[data-garn-info]', root), vorschlaege = $('[data-garn-vorschlaege]', root), tipp = $('[data-garn-tipp]', root);
    var garne = $$('.garn__item', root).map(function (b) { return { el: b, hex: b.dataset.garnHex, name: b.dataset.garnName, nr: b.dataset.garnNr }; });
    var aktStoff = { hex: '#14140f', name: 'Schwarz' }, aktGarn = garne.filter(function (g) { return g.name === 'Elfenbein'; })[0] || garne[0];
    function bewerten() {
      if (!aktGarn) return;
      stoff.style.setProperty('--stoff', aktStoff.hex);
      probe.style.setProperty('--garn', aktGarn.hex);
      garne.forEach(function (g) { g.el.setAttribute('aria-checked', g === aktGarn ? 'true' : 'false'); });
      var k = kontrast(aktStoff.hex, aktGarn.hex), urteil, klasse;
      if (k >= 7) { urteil = 'Sehr gut lesbar – auch kleine Schrift.'; klasse = 'gut'; }
      else if (k >= 4.5) { urteil = 'Gut lesbar – ideal für Logos und Schrift ab 8 mm.'; klasse = 'gut'; }
      else if (k >= 2.5) { urteil = 'Dezent Ton-in-Ton – edel bei großen Motiven, kleine Schrift wird schwer lesbar.'; klasse = 'warn'; }
      else { urteil = 'Kaum Kontrast – wirkt fast unsichtbar. Nur als bewusster Ton-in-Ton-Effekt wählen.'; klasse = 'schlecht'; }
      var mini = $('[data-garn-mini-stoff]', root);
      if (mini) {
        mini.style.background = aktStoff.hex; mini.style.color = aktGarn.hex;
        $('[data-garn-mini-info]', root).textContent = aktGarn.nr + ' · ' + aktGarn.name + ' auf ' + aktStoff.name + ' · Kontrast ' + k.toFixed(1).replace('.', ',') + ' : 1';
      }
      info.innerHTML = '<strong>' + esc(aktGarn.nr + ' · ' + aktGarn.name) + '</strong> auf <strong>' + esc(aktStoff.name) + '</strong><br><span class="zxt__status is-' + klasse + '">Kontrast ' + k.toFixed(1).replace('.', ',') + ' : 1 – ' + urteil + '</span>';
      var beste = garne.slice().sort(function (a, b) { return kontrast(aktStoff.hex, b.hex) - kontrast(aktStoff.hex, a.hex); });
      // bunte Vorschlaege: gute Kontraste, aber nicht nur Schwarz/Weiss
      var bunt = beste.filter(function (g) { var r = hexRgb(g.hex), sat = Math.max.apply(0, r) - Math.min.apply(0, r); return sat > 60 && kontrast(aktStoff.hex, g.hex) >= 3; }).slice(0, 5);
      var neutral = beste.slice(0, 3);
      vorschlaege.innerHTML = '<p class="zxa__label">Passt gut auf ' + esc(aktStoff.name) + '</p><div class="zxt-garn__chips">' +
        neutral.concat(bunt).map(function (g) { return '<button type="button" data-garn-wahl="' + g.nr + '"><i style="background:' + g.hex + '"></i>' + esc(g.name) + '</button>'; }).join('') + '</div>';
    }
    $('[data-garn-stoffe]', root).addEventListener('click', function (e) {
      var b = e.target.closest('[data-stoff-hex]'); if (!b) return;
      $$('[data-stoff-hex]', root).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      aktStoff = { hex: b.dataset.stoffHex, name: b.dataset.stoffName }; bewerten();
    });
    root.addEventListener('click', function (e) {
      var g = e.target.closest('.garn__item, [data-garn-wahl]'); if (!g) return;
      var nr = g.dataset.garnNr || g.dataset.garnWahl;
      aktGarn = garne.filter(function (x) { return x.nr === nr; })[0] || aktGarn; bewerten();
    });
    eingabe.addEventListener('input', function () {
      var t = eingabe.value.trim() || 'Dein Text';
      probe.textContent = t;
      var m = $('[data-garn-mini-text]', root); if (m) m.textContent = t;
    });
    if (tipp) tipp.textContent = '· ' + garne.length + ' Farben, antippen zum Ausprobieren';
    bewerten();
  }

  /* ============================================================
     7 · SAMMELBESTELLUNG (Namen + Groessen, CSV)
     ============================================================ */
  var GROESSEN = ['', '98/104', '110/116', '122/128', '134/146', '152/164', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
  function sammelbestellung(root) {
    var KEY = 'zx-sammelbestellung', daten = speicher(KEY) || { team: '', produkt: '', zeilen: [{ name: '', groesse: '', nr: '' }] };
    var tbody = $('[data-sb-zeilen]', root), summe = $('[data-sb-summe]', root), team = $('[data-sb-team]', root), produkt = $('[data-sb-produkt]', root);
    var preise = json($('[data-preis-daten]', root) || document.createElement('i')) || [], mindest = +root.dataset.mindest || 1;
    team.value = daten.team || ''; produkt.value = daten.produkt || '';
    function sichern() { speicher(KEY, daten); }
    function zeichnen() {
      tbody.innerHTML = daten.zeilen.map(function (z, i) {
        return '<tr><td>' + (i + 1) + '</td>' +
          '<td><input type="text" maxlength="20" aria-label="Name ' + (i + 1) + '" value="' + esc(z.name) + '" data-sb-feld="name" data-i="' + i + '" placeholder="Name"></td>' +
          '<td><select aria-label="Größe ' + (i + 1) + '" data-sb-feld="groesse" data-i="' + i + '">' + GROESSEN.map(function (g) { return '<option' + (g === z.groesse ? ' selected' : '') + ' value="' + g + '">' + (g || '–') + '</option>'; }).join('') + '</select></td>' +
          '<td><input type="text" inputmode="numeric" maxlength="3" aria-label="Nummer ' + (i + 1) + '" value="' + esc(z.nr) + '" data-sb-feld="nr" data-i="' + i + '" placeholder="–"></td>' +
          '<td><button type="button" class="zxt-sb__weg" data-sb-weg="' + i + '" aria-label="Zeile ' + (i + 1) + ' entfernen">×</button></td></tr>';
      }).join('');
      auswerten();
    }
    function auswerten() {
      var gefuellt = daten.zeilen.filter(function (z) { return z.name.trim() || z.groesse; });
      var proGroesse = {};
      gefuellt.forEach(function (z) { var g = z.groesse || 'ohne Größe'; proGroesse[g] = (proGroesse[g] || 0) + 1; });
      var namen = gefuellt.filter(function (z) { return z.name.trim(); }).length, n = gefuellt.length;
      var html = '<div class="zxt-sb__zahlen"><div><b>' + n + '</b><span>Teile</span></div><div><b>' + namen + '</b><span>mit Namen</span></div><div><b>' + Object.keys(proGroesse).length + '</b><span>Größen</span></div></div>';
      if (n) html += '<ul class="zxt-sb__groessen" role="list">' + GROESSEN.concat(['ohne Größe']).filter(function (g) { return proGroesse[g]; }).map(function (g) { return '<li><b>' + proGroesse[g] + '×</b> ' + esc(g) + '</li>'; }).join('') + '</ul>';
      if (n && n < mindest) html += '<p class="zxt__status is-warn">Noch ' + (mindest - n) + ' Teil' + (mindest - n > 1 ? 'e' : '') + ' bis zur Mindestmenge von ' + mindest + '.</p>';
      if (n >= mindest && preise.length && namen) {
        var ns = staffel(preise, 'Namensstick', namen);
        if (ns) html += '<p class="zxt__hinweis">Namensstick: ' + namen + ' × ' + euro.format(ns.p / 100) + ' = <strong>' + euro.format(namen * ns.p / 100) + '</strong> zusätzlich zu Textil und Logo.</p>';
      }
      summe.innerHTML = html;
    }
    tbody.addEventListener('input', function (e) {
      var f = e.target.dataset.sbFeld; if (!f) return;
      daten.zeilen[+e.target.dataset.i][f] = e.target.value; sichern(); auswerten();
    });
    tbody.addEventListener('change', function (e) { if (e.target.dataset.sbFeld) { daten.zeilen[+e.target.dataset.i][e.target.dataset.sbFeld] = e.target.value; sichern(); auswerten(); } });
    tbody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sb-weg]'); if (!b) return;
      daten.zeilen.splice(+b.dataset.sbWeg, 1);
      if (!daten.zeilen.length) daten.zeilen.push({ name: '', groesse: '', nr: '' });
      sichern(); zeichnen();
    });
    $('[data-sb-neu]', root).addEventListener('click', function () {
      daten.zeilen.push({ name: '', groesse: '', nr: '' }); sichern(); zeichnen();
      var felder = $$('[data-sb-feld="name"]', tbody); felder[felder.length - 1].focus();
    });
    $('[data-sb-uebernehmen]', root).addEventListener('click', function () {
      var text = $('[data-sb-text]', root).value, neu = [];
      text.split(/\r?\n/).forEach(function (zeile) {
        if (!zeile.trim()) return;
        var t = zeile.split(/\t|;|,/).map(function (x) { return x.trim(); });
        var g = (t[1] || '').toUpperCase().replace('XXXL', '3XL');
        var treffer = GROESSEN.filter(function (x) { return x.toUpperCase() === g; })[0] || '';
        neu.push({ name: t[0] || '', groesse: treffer, nr: (t[2] || '').replace(/\D/g, '').slice(0, 3) });
      });
      if (!neu.length) return;
      daten.zeilen = daten.zeilen.filter(function (z) { return z.name.trim() || z.groesse; }).concat(neu);
      $('[data-sb-text]', root).value = '';
      $('.zxt-sb__einfuegen', root).open = false;
      sichern(); zeichnen();
    });
    team.addEventListener('input', function () { daten.team = team.value; sichern(); });
    produkt.addEventListener('input', function () { daten.produkt = produkt.value; sichern(); });
    function alsText(trenner) {
      var kopf = ['Nr', 'Name', 'Größe', 'Nummer'];
      var zeilen = daten.zeilen.filter(function (z) { return z.name.trim() || z.groesse; }).map(function (z, i) { return [i + 1, z.name.trim(), z.groesse, z.nr]; });
      var q = function (v) { v = String(v); return trenner === ';' && /[;"\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; };
      var vor = [];
      if (daten.team) vor.push(['Team', daten.team]);
      if (daten.produkt) vor.push(['Produkt', daten.produkt]);
      return vor.concat(vor.length ? [[]] : []).concat([kopf]).concat(zeilen).map(function (r) { return r.map(q).join(trenner); }).join('\r\n');
    }
    $('[data-sb-csv]', root).addEventListener('click', function () {
      var blob = new Blob(['﻿' + alsText(';')], { type: 'text/csv;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'Sammelbestellung' + (daten.team ? '-' + daten.team.replace(/[^\wäöüÄÖÜß-]+/g, '-') : '') + '.csv';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    });
    $('[data-sb-kopieren]', root).addEventListener('click', function (e) {
      var knopf = e.currentTarget, alt = knopf.textContent, text = alsText('\t');
      var fertig = function () { knopf.textContent = 'Kopiert ✓'; setTimeout(function () { knopf.textContent = alt; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(fertig, function () {});
      // Liste auch ins Anfrageformular uebernehmen, falls vorhanden
      var nachricht = document.querySelector('#anfrage textarea[name="contact[body]"]');
      if (nachricht && !nachricht.value.trim()) nachricht.value = 'Sammelbestellung' + (daten.team ? ' ' + daten.team : '') + ':\n' + alsText(' | ');
    });
    zeichnen();
  }

  /* ============================================================
     8 · FAQ-SUCHE  ·  9 · IDEEN-FILTER
     ============================================================ */
  function faq(root) {
    var feld = $('[data-faq-suche]', root); if (!feld) return;
    var leer = $('[data-faq-leer]', root), eintraege = $$('[data-faq-eintrag]', root), themen = $$('[data-faq-thema]', root);
    feld.addEventListener('input', function () {
      var q = feld.value.trim().toLowerCase(), treffer = 0;
      eintraege.forEach(function (d) {
        var an = !q || d.textContent.toLowerCase().indexOf(q) > -1;
        d.hidden = !an; if (an) treffer++;
        if (q && an && q.length > 2) d.open = true; else if (!q) d.open = false;
      });
      themen.forEach(function (t) {
        var n = t.nextElementSibling, sichtbar = false;
        while (n && !n.matches('[data-faq-thema]')) { if (!n.hidden) sichtbar = true; n = n.nextElementSibling; }
        t.hidden = !sichtbar;
      });
      leer.hidden = treffer > 0;
    });
  }
  function ideen(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ideen-filter]'); if (!b) return;
      var f = b.dataset.ideenFilter;
      $$('[data-ideen-filter]', root).forEach(function (x) { x.classList.toggle('is-aktiv', x === b); x.setAttribute('aria-pressed', x === b); });
      $$('[data-ideen-anlass]', root).forEach(function (li) { li.hidden = !!f && li.dataset.ideenAnlass !== f; });
    });
  }

  /* ============================================================
     10 · GALERIE (Metaobjekte "Projekt"): Filter + Grossansicht
     ============================================================ */
  function galerie(root) {
    var dialog = $('[data-galerie-dialog]', root);
    var gross = $('[data-galerie-gross]', root), thumbs = $('[data-galerie-thumbs]', root), text = $('[data-galerie-text]', root);
    var aktuell = -1, bildNr = 0, daten = null;
    function sichtbare() { return $$('.zxg__item', root).filter(function (li) { return !li.hidden; }); }

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-galerie-filter]');
      if (f) {
        var wert = f.dataset.galerieFilter;
        $$('[data-galerie-filter]', root).forEach(function (b) { b.classList.toggle('is-aktiv', b === f); b.setAttribute('aria-pressed', b === f); });
        $$('.zxg__item', root).forEach(function (li) { li.hidden = !!wert && li.dataset.galerieAnlass !== wert; });
        return;
      }
      var k = e.target.closest('[data-galerie-oeffnen]');
      if (k) oeffnen(sichtbare().indexOf(k.closest('.zxg__item')));
    });
    if (!dialog) return;

    function bild(nr) {
      if (!daten || !daten.bilder.length) return;
      bildNr = (nr + daten.bilder.length) % daten.bilder.length;
      var b = daten.bilder[bildNr];
      gross.classList.remove('is-da');
      gross.onload = function () { gross.classList.add('is-da'); };
      gross.src = b.l; gross.alt = b.alt || daten.titel;
      $$('button', thumbs).forEach(function (t, i) { t.setAttribute('aria-current', i === bildNr ? 'true' : 'false'); });
    }
    function oeffnen(index) {
      var liste = sichtbare(); if (!liste.length || index < 0) return;
      aktuell = (index + liste.length) % liste.length;
      daten = json($('[data-galerie-daten]', liste[aktuell])); if (!daten) return;
      thumbs.innerHTML = daten.bilder.length > 1 ? daten.bilder.map(function (b, i) {
        return '<button type="button" data-galerie-bild="' + i + '" aria-label="Foto ' + (i + 1) + '"><img src="' + esc(b.s.replace(/width=\d+/, 'width=160')) + '" alt=""></button>';
      }).join('') : '';
      var chips = [daten.anlass, daten.verfahren].filter(Boolean).map(function (c) { return '<small>' + esc(c) + '</small>'; }).join('');
      var knopf = daten.produkt
        ? '<a class="zxa__btn" href="' + esc(daten.produkt.url) + '">Das will ich auch →</a><span class="zxg__preis">' + esc(daten.produkt.titel) + ' · ' + (daten.produkt.ab ? 'ab ' : '') + esc(daten.produkt.preis) + '</span>'
        : '<a class="zxa__btn" href="/pages/contact">Ähnliches anfragen →</a>';
      text.innerHTML = '<div class="zxg__chips">' + chips + '</div><h3>' + esc(daten.titel) + '</h3>' +
        (daten.beschreibung ? '<p>' + esc(daten.beschreibung).replace(/\n/g, '<br>') + '</p>' : '') +
        (daten.zitat ? '<blockquote>„' + esc(daten.zitat) + '“' + (daten.kunde ? '<cite>– ' + esc(daten.kunde) + '</cite>' : '') + '</blockquote>' : (daten.kunde ? '<p class="zxa__klein">' + esc(daten.kunde) + '</p>' : '')) +
        '<div class="zxg__aktion">' + knopf + '</div>' +
        '<p class="zxa__klein zxg__zaehler">' + (aktuell + 1) + ' / ' + liste.length + '</p>';
      bild(0);
      if (!dialog.open) { dialog.showModal(); document.documentElement.classList.add('zxg-offen'); }
    }
    function zu() { if (dialog.open) dialog.close(); }
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('zxg-offen'); gross.removeAttribute('src'); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) return zu();
      if (e.target.closest('[data-galerie-zu]')) return zu();
      if (e.target.closest('[data-galerie-vor]')) return oeffnen(aktuell + 1);
      if (e.target.closest('[data-galerie-zurueck]')) return oeffnen(aktuell - 1);
      var t = e.target.closest('[data-galerie-bild]'); if (t) bild(+t.dataset.galerieBild);
    });
    gross.addEventListener('click', function () { if (daten && daten.bilder.length > 1) bild(bildNr + 1); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); oeffnen(aktuell + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); oeffnen(aktuell - 1); }
    });
    var startX = null;
    dialog.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    dialog.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) < 50) return;
      if (daten && daten.bilder.length > 1 && bildNr + (dx < 0 ? 1 : -1) >= 0 && bildNr + (dx < 0 ? 1 : -1) < daten.bilder.length) bild(bildNr + (dx < 0 ? 1 : -1));
      else oeffnen(aktuell + (dx < 0 ? 1 : -1));
    });
  }

  /* ============================================================
     11 · ABGABESCHEIN (mitgebrachte Textilien, Stickservice vor Ort)
     ============================================================ */
  var ARTEN = {
    'Servietten': ['Ecke unten rechts', 'Mittig', 'Ecke unten links'],
    'Tischdecken & Läufer': ['Ecke', 'Mitte Längsseite', 'Mittig'],
    'Schürzen': ['Brust mittig', 'Latz oben', 'Tasche', 'Unten rechts'],
    'Kochjacken': ['Brust links (Herzseite)', 'Brust rechts', 'Ärmel', 'Kragen', 'Rücken'],
    'Handtücher & Bademäntel': ['Bordüre', 'Ecke', 'Brust links', 'Rücken'],
    'Kissen & Bettwäsche': ['Mittig', 'Ecke', 'Saum'],
    'Arbeitskleidung': ['Brust links (Herzseite)', 'Brust rechts', 'Rücken', 'Ärmel'],
    'Shirts, Polos & Hoodies': ['Brust links (Herzseite)', 'Brust rechts', 'Nacken', 'Ärmel', 'Rücken'],
    'Caps & Mützen': ['Vorne', 'Seite', 'Hinten'],
    'Taschen': ['Vorderseite', 'Tasche außen', 'Klappe'],
    'Babysachen': ['Brust', 'Ecke', 'Mittig'],
    'Sonstiges': ['Bitte beschreiben']
  };
  var MOTIVE = ['Name / Text', 'Monogramm / Initialen', 'Logo (schicke ich mit)', 'Motiv aus eurer Auswahl'];
  function abgabe(root) {
    var KEY = 'zx-abgabeschein';
    var leer = function () { return { art: '', anzahl: 1, position: '', motiv: '', details: '', garn: '' }; };
    var d = speicher(KEY) || { name: '', tel: '', abgabe: '', fertig: '', zeilen: [leer()] };
    var liste = $('[data-ab-liste]', root), summe = $('[data-ab-summe]', root), druck = $('[data-ab-druck]', root);
    var ticketBox = $('[data-ab-ticket]', root), stelle = root.dataset.stelle || 'der Abgabestelle';
    var kopf = { name: $('[data-ab-name]', root), tel: $('[data-ab-tel]', root), abgabe: $('[data-ab-abgabe]', root), fertig: $('[data-ab-fertig]', root) };
    var heute = isoDatum(new Date());
    kopf.abgabe.min = heute; kopf.fertig.min = heute;
    Object.keys(kopf).forEach(function (k) {
      kopf[k].value = d[k] || '';
      kopf[k].addEventListener('input', function () { d[k] = kopf[k].value; sichern(); auswerten(); });
    });
    function sichern() { speicher(KEY, d); }
    function option(wert, aktiv, text) { return '<option value="' + esc(wert) + '"' + (wert === aktiv ? ' selected' : '') + '>' + esc(text || wert || '– bitte wählen –') + '</option>'; }
    function zeichnen() {
      liste.innerHTML = d.zeilen.map(function (z, i) {
        var pos = ARTEN[z.art] || [];
        return '<li class="zxt-ab__zeile">' +
          '<b class="zxt-ab__nr">' + (i + 1) + '</b>' +
          '<label class="zxa__feld"><span>Textil</span><select data-ab-feld="art" data-i="' + i + '">' + option('', z.art) + Object.keys(ARTEN).map(function (a) { return option(a, z.art); }).join('') + '</select></label>' +
          '<label class="zxa__feld zxt-ab__anzahl"><span>Anzahl</span><input type="number" min="1" max="999" value="' + esc(z.anzahl) + '" data-ab-feld="anzahl" data-i="' + i + '"></label>' +
          '<label class="zxa__feld"><span>Position</span><input type="text" maxlength="40" list="zxab-pos-' + i + '" value="' + esc(z.position) + '" placeholder="' + esc(pos[0] || 'z. B. Brust links') + '" data-ab-feld="position" data-i="' + i + '"><datalist id="zxab-pos-' + i + '">' + pos.map(function (p) { return '<option value="' + esc(p) + '">'; }).join('') + '</datalist></label>' +
          '<label class="zxa__feld"><span>Motiv</span><select data-ab-feld="motiv" data-i="' + i + '">' + option('', z.motiv) + MOTIVE.map(function (m) { return option(m, z.motiv); }).join('') + '</select></label>' +
          '<label class="zxa__feld zxt-ab__details"><span>Text / Details</span><input type="text" maxlength="80" value="' + esc(z.details) + '" placeholder="z. B. „Hotel Rheinblick“ oder Namen je Teil" data-ab-feld="details" data-i="' + i + '"></label>' +
          '<label class="zxa__feld"><span>Garnfarbe</span><input type="text" maxlength="30" value="' + esc(z.garn) + '" placeholder="z. B. 29 Elfenbein" data-ab-feld="garn" data-i="' + i + '"></label>' +
          '<button type="button" class="zxt-sb__weg" data-ab-weg="' + i + '" aria-label="Zeile ' + (i + 1) + ' entfernen">×</button>' +
          '</li>';
      }).join('');
      auswerten();
    }
    function gefuellt() { return d.zeilen.filter(function (z) { return z.art; }); }
    function auswerten() {
      var z = gefuellt(), teile = z.reduce(function (s, x) { return s + Math.max(1, parseInt(x.anzahl, 10) || 1); }, 0);
      var html = '<div class="zxt-sb__zahlen"><div><b>' + teile + '</b><span>Teile</span></div><div><b>' + z.length + '</b><span>Textilarten</span></div><div><b>' + z.filter(function (x) { return /Logo/.test(x.motiv); }).length + '</b><span>mit Logo</span></div></div>';
      var hinweise = [];
      if (z.some(function (x) { return /Logo/.test(x.motiv); })) hinweise.push('Logo bitte als Datei mitschicken (SVG, PDF oder PNG) – <a href="/pages/logo-vorgaben">jetzt prüfen</a>.');
      if (z.some(function (x) { return x.art === 'Kochjacken'; })) hinweise.push('Kochjacken: Klassiker ist der Name auf der Brust links, darunter optional die Position („Sous-Chef“).');
      if (z.some(function (x) { return x.art === 'Servietten'; })) hinweise.push('Servietten: Monogramme wirken am edelsten Ton in Ton oder in Gold/Silber, ca. 2–4 cm hoch.');
      if (d.fertig && d.abgabe && d.fertig <= d.abgabe) hinweise.push('Das Fertig-Datum liegt vor oder auf dem Abgabetag – bitte prüfen.');
      html += hinweise.map(function (h) { return '<p class="zxt__hinweis">' + h + '</p>'; }).join('');
      summe.innerHTML = z.length ? html : '<p class="zxt__leer">Wähle oben dein erstes Textil aus.</p>';
      if (ticketBox) ticketZeigen();
      document.dispatchEvent(new CustomEvent('zx-plan-update'));
    }
    function alsText() {
      var z = gefuellt();
      var zeilen = ['ABGABESCHEIN · ' + ZXT_SHOP + (d.ticket ? ' · Ticket ' + d.ticket : '')];
      if (d.name) zeilen.push('Name: ' + d.name);
      if (d.tel) zeilen.push('Telefon: ' + d.tel);
      if (d.abgabe) zeilen.push('Abgabe: ' + datumLang.format(ausIso(d.abgabe)));
      if (d.fertig) zeilen.push('Fertig bis: ' + datumLang.format(ausIso(d.fertig)));
      zeilen.push('');
      z.forEach(function (x, i) { zeilen.push((i + 1) + '. ' + (x.anzahl || 1) + '× ' + x.art + (x.position ? ' · ' + x.position : '') + (x.motiv ? ' · ' + x.motiv : '') + (x.details ? ' · „' + x.details + '“' : '') + (x.garn ? ' · Garn: ' + x.garn : '')); });
      return zeilen.join('\n');
    }
    liste.addEventListener('input', function (e) { var f = e.target.dataset.abFeld; if (!f) return; d.zeilen[+e.target.dataset.i][f] = e.target.value; sichern(); auswerten(); });
    liste.addEventListener('change', function (e) {
      var f = e.target.dataset.abFeld; if (!f) return;
      d.zeilen[+e.target.dataset.i][f] = e.target.value; sichern();
      if (f === 'art') zeichnen(); else auswerten();
    });
    liste.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ab-weg]'); if (!b) return;
      d.zeilen.splice(+b.dataset.abWeg, 1); if (!d.zeilen.length) d.zeilen.push(leer()); sichern(); zeichnen();
    });
    $('[data-ab-neu]', root).addEventListener('click', function () { d.zeilen.push(leer()); sichern(); zeichnen(); var s = $$('[data-ab-feld="art"]', liste); s[s.length - 1].focus(); });
    $('[data-ab-leeren]', root).addEventListener('click', function () {
      d = { name: '', tel: '', abgabe: '', fertig: '', zeilen: [leer()] }; speicher(KEY, null);
      Object.keys(kopf).forEach(function (k) { kopf[k].value = ''; }); zeichnen();
      var p = speicher(PLAN_KEY) || {}; delete p.ticket; speicher(PLAN_KEY, p); document.dispatchEvent(new CustomEvent('zx-plan-update'));
    });
    $('[data-ab-anfrage]', root).addEventListener('click', function () {
      var feld = document.querySelector('#anfrage textarea[name="contact[body]"]');
      if (!feld) return;
      feld.value = alsText() + (feld.value.trim() ? '\n\n' + feld.value : '');
      var n = document.querySelector('#anfrage input[name="contact[name]"]'); if (n && !n.value && d.name) n.value = d.name;
      document.getElementById('anfrage').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    function ticketZeigen() {
      if (!d.ticket) { ticketBox.hidden = true; return; }
      var z = gefuellt(), teile = z.reduce(function (s, x) { return s + Math.max(1, parseInt(x.anzahl, 10) || 1); }, 0);
      ticketBox.hidden = false;
      ticketBox.innerHTML = '<div class="zxt-ticket">' +
        '<div class="zxt-ticket__haupt"><p class="zxt-ticket__label">Abgabe-Ticket</p>' +
        '<p class="zxt-ticket__code">' + esc(d.ticket) + '</p>' +
        '<dl><div><dt>Teile</dt><dd>' + teile + '</dd></div><div><dt>Abgabe</dt><dd>' + (d.abgabe ? datumLang.format(ausIso(d.abgabe)) : 'flexibel') + '</dd></div><div><dt>Bei</dt><dd>' + esc(stelle) + '</dd></div></dl></div>' +
        '<div class="zxt-ticket__abriss"><ol><li>Ticket ausdrucken oder Screenshot machen</li><li>Mit deinen Textilien bei ' + esc(stelle) + ' abgeben</li><li>Status jederzeit mit <b>' + esc(d.ticket) + '</b> abfragen</li></ol></div></div>';
    }
    $('[data-ab-ticket-knopf]', root).addEventListener('click', function () {
      if (!gefuellt().length) { summe.innerHTML = '<p class="zxt__status is-warn">Bitte zuerst mindestens ein Textil eintragen.</p>'; return; }
      if (!d.ticket) d.ticket = 'ZA' + String(Math.floor(1000 + Math.random() * 9000));
      sichern(); ticketZeigen(); planMelden('ticket');
      document.dispatchEvent(new CustomEvent('zx-abgabe-update-intern'));
      ticketBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    $('[data-ab-drucken]', root).addEventListener('click', function () {
      var z = gefuellt();
      if (!z.length) { summe.innerHTML = '<p class="zxt__status is-warn">Bitte zuerst mindestens ein Textil eintragen.</p>'; return; }
      druck.innerHTML = '<div class="zxab-kd">' +
        '<header><p>' + esc(ZXT_SHOP) + '</p><h2>Abgabeschein' + (d.ticket ? ' · ' + esc(d.ticket) : '') + '</h2></header>' +
        '<dl>' + [['Name', d.name], ['Telefon', d.tel], ['Abgabe', d.abgabe && datumLang.format(ausIso(d.abgabe))], ['Fertig bis', d.fertig && datumLang.format(ausIso(d.fertig))]].map(function (p) { return '<div><dt>' + p[0] + '</dt><dd>' + esc(p[1] || '') + '</dd></div>'; }).join('') + '</dl>' +
        '<table><thead><tr><th>#</th><th>Anzahl</th><th>Textil</th><th>Position</th><th>Motiv</th><th>Text / Details</th><th>Garn</th></tr></thead><tbody>' +
        z.map(function (x, i) { return '<tr><td>' + (i + 1) + '</td><td>' + esc(x.anzahl || 1) + '</td><td>' + esc(x.art) + '</td><td>' + esc(x.position) + '</td><td>' + esc(x.motiv) + '</td><td>' + esc(x.details) + '</td><td>' + esc(x.garn) + '</td></tr>'; }).join('') +
        '</tbody></table>' +
        '<footer><p>Bitte Textilien gewaschen und ohne Weichspüler abgeben. Wir prüfen jedes Teil vor dem Sticken.</p><p>Unterschrift: ______________________</p></footer></div>';
      document.body.classList.add('zxab-druck');
      var weg = function () { document.body.classList.remove('zxab-druck'); window.removeEventListener('afterprint', weg); };
      window.addEventListener('afterprint', weg);
      window.print();
      setTimeout(weg, 1500);
    });
    document.addEventListener('zx-abgabe-update', function () {
      var neu = speicher(KEY); if (!neu) return;
      d = neu; if (!d.zeilen || !d.zeilen.length) d.zeilen = [leer()];
      Object.keys(kopf).forEach(function (k) { kopf[k].value = d[k] || ''; });
      zeichnen();
    });
    zeichnen();
  }

  /* ============================================================
     12 · STICK-STUDIO (Live-Vorschau auf Textilien, Rheingau-Motive)
     ============================================================ */
  var PLAN_KEY = 'zx-stickplan';
  function planMelden(teil) { var p = speicher(PLAN_KEY) || {}; p[teil] = true; speicher(PLAN_KEY, p); document.dispatchEvent(new CustomEvent('zx-plan-update')); }

  var TEXTILIEN = {
    kochjacke: {
      name: 'Kochjacke', art: 'Kochjacken', pos: 'Brust links (Herzseite)', stoff: '#f7f7f4', feld: { x: 270, y: 140, w: 62 },
      svg: function (c) {
        return '<path d="M124 74 L168 58 L232 58 L276 74 L322 104 L352 300 L318 306 L300 176 L300 366 L100 366 L100 176 L82 306 L48 300 L78 104 Z" fill="' + c + '" stroke="rgba(0,0,0,.18)" stroke-width="2" stroke-linejoin="round"/>' +
          '<path d="M168 58 L168 40 Q200 34 232 40 L232 58 Q200 66 168 58 Z" fill="' + c + '" stroke="rgba(0,0,0,.2)" stroke-width="2"/>' +
          '<path d="M168 62 Q186 120 236 132 L236 366" fill="none" stroke="rgba(0,0,0,.14)" stroke-width="2"/>' +
          [150, 200, 250, 300].map(function (y) { return '<circle cx="186" cy="' + y + '" r="5.5" fill="rgba(0,0,0,.16)"/><circle cx="214" cy="' + (y + 4) + '" r="5.5" fill="rgba(0,0,0,.16)"/>'; }).join('') +
          '<path d="M60 290 L84 294 M340 290 L316 294" stroke="rgba(0,0,0,.14)" stroke-width="2"/>';
      }
    },
    schuerze: {
      name: 'Schürze', art: 'Schürzen', pos: 'Brust mittig', stoff: '#3b3d40', feld: { x: 200, y: 140, w: 112 },
      svg: function (c) {
        return '<path d="M150 72 Q200 18 250 72" fill="none" stroke="rgba(0,0,0,.35)" stroke-width="6" stroke-linecap="round"/>' +
          '<path d="M142 72 L258 72 L264 176 L318 182 Q330 280 314 372 L86 372 Q70 280 82 182 L136 176 Z" fill="' + c + '" stroke="rgba(0,0,0,.2)" stroke-width="2" stroke-linejoin="round"/>' +
          '<path d="M82 182 L40 196 M318 182 L360 196" stroke="rgba(0,0,0,.35)" stroke-width="6" stroke-linecap="round"/>' +
          '<rect x="150" y="236" width="100" height="74" rx="8" fill="none" stroke="rgba(255,255,255,.18)" stroke-width="2" stroke-dasharray="5 4"/>';
      }
    },
    serviette: {
      name: 'Serviette', art: 'Servietten', pos: 'Ecke unten rechts', stoff: '#efe6d2', feld: { x: 258, y: 286, w: 96, mono: true },
      svg: function (c) {
        return '<rect x="56" y="56" width="288" height="288" rx="6" fill="' + c + '" stroke="rgba(0,0,0,.14)" stroke-width="2"/>' +
          '<rect x="72" y="72" width="256" height="256" rx="3" fill="none" stroke="rgba(0,0,0,.12)" stroke-width="1.5" stroke-dasharray="3 4"/>' +
          '<path d="M56 56 L200 200 L56 344 Z" fill="rgba(0,0,0,.035)"/>';
      }
    },
    handtuch: {
      name: 'Handtuch', art: 'Handtücher & Bademäntel', pos: 'Bordüre', stoff: '#f7f7f4', feld: { x: 200, y: 292, w: 200 },
      svg: function (c) {
        return '<rect x="72" y="40" width="256" height="330" rx="14" fill="' + c + '" stroke="rgba(0,0,0,.14)" stroke-width="2"/>' +
          '<rect x="72" y="258" width="256" height="66" fill="rgba(0,0,0,.05)"/><path d="M72 258 H328 M72 324 H328" stroke="rgba(0,0,0,.12)" stroke-width="2"/>' +
          '<path d="M90 352 V368 M110 352 V368 M130 352 V368 M150 352 V368 M170 352 V368 M190 352 V368 M210 352 V368 M230 352 V368 M250 352 V368 M270 352 V368 M290 352 V368 M310 352 V368" stroke="rgba(0,0,0,.12)" stroke-width="2"/>';
      }
    },
    kissen: {
      name: 'Kissen', art: 'Kissen & Bettwäsche', pos: 'Mittig', stoff: '#d8c7a6', feld: { x: 200, y: 206, w: 190 },
      svg: function (c) {
        return '<path d="M70 70 Q200 52 330 70 Q348 200 330 330 Q200 348 70 330 Q52 200 70 70 Z" fill="' + c + '" stroke="rgba(0,0,0,.16)" stroke-width="2"/>' +
          '<path d="M86 86 Q200 72 314 86 Q328 200 314 314 Q200 328 86 314 Q72 200 86 86 Z" fill="none" stroke="rgba(0,0,0,.1)" stroke-width="1.5" stroke-dasharray="4 5"/>';
      }
    }
  };
  var STOFFE = [['Weiß', '#f7f7f4'], ['Natur', '#efe6d2'], ['Sand', '#d8c7a6'], ['Leinengrau', '#c9c3b6'], ['Anthrazit', '#3b3d40'], ['Schwarz', '#1b1b1b'], ['Navy', '#1c2433'], ['Oliv', '#5b5a3a'], ['Bordeaux', '#5c1a24']];
  // Rheingau-Motive als kleine Pfade (Mittelpunkt 0,0, ca. 40 x 40)
  var MOTIVE_SVG = {
    'Traube': '<circle cx="-7" cy="-6" r="6"/><circle cx="6" cy="-6" r="6"/><circle cx="0" cy="4" r="6"/><circle cx="-12" cy="4" r="6"/><circle cx="12" cy="4" r="6"/><circle cx="-6" cy="14" r="6"/><circle cx="6" cy="14" r="6"/><circle cx="0" cy="23" r="5.5"/><path d="M0 -12 Q2 -22 12 -24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><path d="M4 -18 Q16 -30 24 -16 Q12 -12 4 -18Z"/>',
    'Weinblatt': '<path d="M0 22 L0 4 M0 4 C-4 -2 -16 -2 -20 -10 C-12 -10 -10 -16 -14 -22 C-6 -20 -4 -22 0 -26 C4 -22 6 -20 14 -22 C10 -16 12 -10 20 -10 C16 -2 4 -2 0 4Z"/>',
    'Rheinwelle': '<path d="M-24 -4 Q-18 -12 -12 -4 T0 -4 T12 -4 T24 -4 M-24 8 Q-18 0 -12 8 T0 8 T12 8 T24 8" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>',
    'Herz': '<path d="M0 20 C-26 2 -18 -20 0 -8 C18 -20 26 2 0 20Z"/>',
    'Stern': '<path d="M0 -22 L6 -7 L22 -7 L9 3 L14 19 L0 9 L-14 19 L-9 3 L-22 -7 L-6 -7Z"/>',
    'Krone': '<path d="M-20 14 L-22 -12 L-10 0 L0 -18 L10 0 L22 -12 L20 14Z"/><rect x="-20" y="16" width="40" height="5" rx="2"/>'
  };

  function stickstudio(root) {
    var schriften = json($('[data-studio-schriften]', root)) || [], garne = json($('[data-studio-garne]', root)) || [];
    var buehne = $('[data-studio-svg]', root), etikett = $('[data-studio-etikett]', root);
    var eingabe = $('[data-studio-text]', root), textLabel = $('[data-studio-text-label]', root);
    var wunsch = ['Garamond', 'Damion', 'Marcellus', 'Oswald', 'Archivo Black', 'Delius'];
    var auswahlSchriften = wunsch.map(function (w) { return schriften.filter(function (f) { return f.name === w || f.name.slice(-w.length) === w; })[0]; }).filter(Boolean);
    auswahlSchriften.forEach(function (f) { f.kurz = f.name.replace(/^\d+\s*[·.\-]\s*/, ''); });
    if (auswahlSchriften.length < 4) auswahlSchriften = schriften.slice(0, 6);
    var z = { textil: 'kochjacke', modus: 'text', text: eingabe.value, motiv: '', schrift: auswahlSchriften[0], garn: garne.filter(function (g) { return g.nr === 2; })[0] || garne[0], stoff: null };
    var monoText = 'AK';

    // Steuerelemente aufbauen
    $('[data-studio-textil]', root).innerHTML = Object.keys(TEXTILIEN).map(function (k) { return '<button type="button" data-textil="' + k + '" aria-pressed="' + (k === z.textil) + '"' + (k === z.textil ? ' class="is-aktiv"' : '') + '>' + TEXTILIEN[k].name + '</button>'; }).join('');
    $('[data-studio-motive]', root).innerHTML = '<button type="button" class="is-aktiv" data-motiv="" aria-pressed="true">Ohne</button>' + Object.keys(MOTIVE_SVG).map(function (m) {
      return '<button type="button" data-motiv="' + m + '" aria-pressed="false"><svg viewBox="-26 -28 52 54" width="18" height="18" fill="currentColor" aria-hidden="true">' + MOTIVE_SVG[m] + '</svg>' + m + '</button>';
    }).join('');
    $('[data-studio-schriften-liste]', root).innerHTML = auswahlSchriften.map(function (f, i) {
      return '<button type="button" data-schrift="' + i + '" aria-pressed="' + (i === 0) + '"' + (i === 0 ? ' class="is-aktiv"' : '') + ' style="font-family:' + esc(f.css) + ';font-weight:' + esc(f.weight) + ';font-style:' + esc(f.style) + '">Aa<small>' + esc(f.kurz || f.name) + '</small></button>';
    }).join('');
    $('[data-studio-garne-liste]', root).innerHTML = garne.map(function (g) {
      return '<button type="button" role="radio" data-garn="' + g.nr + '" aria-checked="' + (g === z.garn) + '" style="--c:' + g.hex + '" title="' + g.nr + ' · ' + esc(g.name) + '"><span class="visually-hidden">' + g.nr + ' ' + esc(g.name) + '</span></button>';
    }).join('');
    $('[data-studio-stoffe]', root).innerHTML = STOFFE.map(function (s) { return '<button type="button" role="radio" data-stoff="' + s[1] + '" data-stoff-name="' + s[0] + '" aria-checked="false" style="--c:' + s[1] + '" title="' + s[0] + '"><span class="visually-hidden">' + s[0] + '</span></button>'; }).join('');

    function aktiv(sel, attr, wert) { $$(sel, root).forEach(function (b) { var an = String(b.getAttribute(attr)) === String(wert); b.classList.toggle('is-aktiv', an); b.setAttribute(b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', an); }); }
    function stoffName(hex) { var s = STOFFE.filter(function (x) { return x[1] === hex; })[0]; return s ? s[0] : 'Stoff'; }

    function zeichnen() {
      var t = TEXTILIEN[z.textil], stoff = z.stoff || t.stoff, f = t.feld, g = z.garn, s = z.schrift;
      var text = z.modus === 'mono' ? (monoText || 'AK').toUpperCase().slice(0, 3) : (z.text || 'Dein Name');
      var hell = lum(stoff) > 0.5;
      var motivGroesse = f.w < 100 ? 0.55 : 0.8;
      var motiv = z.motiv ? '<g transform="translate(0,' + (z.modus === 'mono' ? -f.w * 0.62 : -30) + ') scale(' + motivGroesse + ')" fill="url(#zxs-garn)" color="' + g.hex + '">' + MOTIVE_SVG[z.motiv] + '</g>' : '';
      var rahmen = z.modus === 'mono' ? '<circle r="' + (f.w * 0.46) + '" fill="none" stroke="' + g.hex + '" stroke-width="2.5" filter="url(#zxs-stich)"/><circle r="' + (f.w * 0.40) + '" fill="none" stroke="' + g.hex + '" stroke-width="1" stroke-dasharray="2 3"/>' : '';
      buehne.innerHTML = '<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">' +
        '<defs><pattern id="zxs-webung" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><path d="M0 2 H4" stroke="' + (hell ? 'rgba(0,0,0,.028)' : 'rgba(255,255,255,.03)') + '" stroke-width="1"/></pattern>' +
        '<pattern id="zxs-garn" width="3" height="3" patternUnits="userSpaceOnUse" patternTransform="rotate(40)"><rect width="3" height="3" fill="' + g.hex + '"/><path d="M0 0.5 H3" stroke="rgba(255,255,255,.22)" stroke-width=".7"/><path d="M0 2.4 H3" stroke="rgba(0,0,0,.18)" stroke-width=".6"/></pattern>' +
        '<filter id="zxs-stich" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="1" stdDeviation=".7" flood-color="#000" flood-opacity=".35"/></filter></defs>' +
        '<g class="zxs-textil">' + t.svg(stoff) + '</g>' +
        '<g class="zxs-textil" style="pointer-events:none">' + (t.svg('url(#zxs-webung)').match(/<(path|rect)[^>]*fill="url\(#zxs-webung\)"[^>]*\/>/g) || []).join('').replace(/stroke="[^"]*"/g, 'stroke="none"') + '</g>' +
        '<g transform="translate(' + f.x + ',' + f.y + ')">' + rahmen + motiv +
        '<text data-zxs-text text-anchor="middle" dominant-baseline="central" fill="url(#zxs-garn)" filter="url(#zxs-stich)" style="font-family:' + esc(s.css) + ';font-weight:' + esc(s.weight) + ';font-style:' + esc(s.style) + '" font-size="' + (z.modus === 'mono' ? f.w * 0.42 : 34) + '"' + (z.motiv && z.modus !== 'mono' ? ' y="8"' : '') + '>' + esc(text) + '</text></g></svg>';
      // Text in die Stickflaeche einpassen
      var el = $('[data-zxs-text]', buehne);
      try {
        var max = z.modus === 'mono' ? f.w * 0.72 : f.w, len = el.getComputedTextLength();
        if (len > max) el.setAttribute('font-size', Math.max(9, parseFloat(el.getAttribute('font-size')) * max / len).toFixed(1));
      } catch (e) {}
      etikett.innerHTML = '<strong>' + t.name + '</strong> · ' + (z.modus === 'mono' ? 'Monogramm' : '„' + esc(text) + '“') + (z.motiv ? ' + ' + z.motiv : '') + ' · ' + esc(s.kurz || s.name) + ' · Garn ' + g.nr + ' ' + esc(g.name) + ' auf ' + stoffName(stoff);
      $('[data-studio-garn-name]', root).textContent = '· ' + g.nr + ' ' + g.name;
      aktiv('[data-stoff]', 'data-stoff', stoff);
    }

    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-textil]'))) { z.textil = b.dataset.textil; z.stoff = null; aktiv('[data-textil]', 'data-textil', z.textil); }
      else if ((b = e.target.closest('[data-modus]'))) {
        z.modus = b.dataset.modus; aktiv('[data-modus]', 'data-modus', z.modus);
        textLabel.textContent = z.modus === 'mono' ? 'Initialen (1–3 Buchstaben)' : 'Dein Text';
        eingabe.maxLength = z.modus === 'mono' ? 3 : 24;
        eingabe.value = z.modus === 'mono' ? monoText : z.text;
      }
      else if ((b = e.target.closest('[data-motiv]'))) { z.motiv = b.dataset.motiv; aktiv('[data-motiv]', 'data-motiv', z.motiv); }
      else if ((b = e.target.closest('[data-schrift]'))) { z.schrift = auswahlSchriften[+b.dataset.schrift]; aktiv('[data-schrift]', 'data-schrift', b.dataset.schrift); }
      else if ((b = e.target.closest('[data-garn]'))) { z.garn = garne.filter(function (g) { return String(g.nr) === b.dataset.garn; })[0]; aktiv('[data-garn]', 'data-garn', b.dataset.garn); }
      else if ((b = e.target.closest('[data-stoff]'))) { z.stoff = b.dataset.stoff; }
      else if (e.target.closest('[data-studio-uebernehmen]')) { return uebernehmen(); }
      else return;
      zeichnen(); planMelden('studio');
    });
    eingabe.addEventListener('input', function () {
      if (z.modus === 'mono') monoText = eingabe.value.replace(/[^A-Za-zÄÖÜäöüß]/g, '').toUpperCase(); else z.text = eingabe.value;
      zeichnen();
    });
    function uebernehmen() {
      var t = TEXTILIEN[z.textil], d = speicher('zx-abgabeschein') || { name: '', tel: '', abgabe: '', fertig: '', zeilen: [] };
      d.zeilen = (d.zeilen || []).filter(function (x) { return x.art; });
      d.zeilen.push({ art: t.art, anzahl: 1, position: t.pos,
        motiv: z.modus === 'mono' ? 'Monogramm / Initialen' : 'Name / Text',
        details: (z.modus === 'mono' ? (monoText || 'AK') + ' im Kreis' : z.text) + (z.motiv ? ' + ' + z.motiv : '') + ' · Schrift ' + (z.schrift.kurz || z.schrift.name) + ' · auf ' + stoffName(z.stoff || t.stoff),
        garn: z.garn.nr + ' ' + z.garn.name });
      speicher('zx-abgabeschein', d);
      planMelden('studio');
      document.dispatchEvent(new CustomEvent('zx-abgabe-update'));
      var ok = $('[data-studio-ok]', root); ok.textContent = '✓ ' + t.name + ' im Abgabeschein';
      setTimeout(function () { ok.textContent = ''; }, 3500);
      var ziel = document.getElementById('abgabe'); if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    zeichnen();
  }

  /* ============================================================
     13 · ABGABESTELLE (Oeffnungszeiten live, Route, Woher kommst du?)
     ============================================================ */
  var TAGE = { 'So': 0, 'Mo': 1, 'Di': 2, 'Mi': 3, 'Do': 4, 'Fr': 5, 'Sa': 6 };
  var TAGNAMEN = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  function abgabestelle(root) {
    var zeiten = json($('[data-ort-zeiten]', root)) || [], status = $('[data-ort-status]', root), liste = $('[data-ort-liste]', root);
    var plan = {};
    zeiten.forEach(function (z) {
      var t = TAGE[(z.tag || '').slice(0, 2)]; if (t === undefined) return;
      plan[t] = (z.zeit || '').split(',').map(function (s) { var m = s.trim().match(/(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})/); return m ? [m[1] * 60 + +m[2], m[3] * 60 + +m[4]] : null; }).filter(Boolean);
    });
    function hhmm(min) { return Math.floor(min / 60) + ':' + String(min % 60).padStart(2, '0'); }
    function aktualisieren() {
      if (!zeiten.length) { status.hidden = true; return; }
      var jetzt = new Date(), tag = jetzt.getDay(), min = jetzt.getHours() * 60 + jetzt.getMinutes();
      var heute = plan[tag] || [], offen = heute.filter(function (z) { return min >= z[0] && min < z[1]; })[0];
      if (offen) {
        var rest = offen[1] - min;
        status.className = 'zxt-ort__status is-offen';
        status.innerHTML = '<i></i>Jetzt geöffnet · ' + (rest <= 60 ? 'schließt in ' + rest + ' Min.' : 'bis ' + hhmm(offen[1]) + ' Uhr');
      } else {
        var naechst = null;
        for (var i = 0; i < 8 && !naechst; i++) {
          var t = (tag + i) % 7, slots = plan[t] || [];
          for (var j = 0; j < slots.length; j++) { if (i > 0 || slots[j][0] > min) { naechst = { i: i, t: t, ab: slots[j][0] }; break; } }
        }
        status.className = 'zxt-ort__status is-zu';
        status.innerHTML = '<i></i>Gerade geschlossen' + (naechst ? ' · öffnet ' + (naechst.i === 0 ? 'heute' : naechst.i === 1 ? 'morgen' : 'am ' + TAGNAMEN[naechst.t]) + ' um ' + hhmm(naechst.ab) + ' Uhr' : '');
      }
      liste.innerHTML = [1, 2, 3, 4, 5, 6, 0].filter(function (t) { return zeiten.some(function (z) { return TAGE[(z.tag || '').slice(0, 2)] === t; }); }).map(function (t) {
        var slots = plan[t] || [];
        return '<li' + (t === tag ? ' class="is-heute"' : '') + '><span>' + TAGNAMEN[t] + '</span><span>' + (slots.length ? slots.map(function (s) { return hhmm(s[0]) + '–' + hhmm(s[1]); }).join(' · ') : 'geschlossen') + '</span></li>';
      }).join('');
    }
    aktualisieren(); setInterval(aktualisieren, 60000);

    var ziel = root.dataset.ziel, weg = $('[data-ort-weg]', root);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ort]'); if (!b) return;
      $$('[data-ort]', root).forEach(function (x) { x.classList.toggle('is-aktiv', x === b); x.setAttribute('aria-pressed', x === b); });
      var m = parseInt(b.dataset.min, 10) || 0, spruch = m <= 10 ? 'Quasi Nachbarn – auf dem Weg zum Bäcker abgeben. ☕' : m <= 20 ? 'Kurzer Ausflug – perfekt mit einem Abstecher in die Weinberge. 🍇' : 'Lohnt sich – und beim Abholen kennst du den Weg schon. 🚗';
      var route = ziel && ziel.replace(/[, ]/g, '') ? 'https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(b.dataset.ort) + '&destination=' + encodeURIComponent(ziel) : '';
      weg.innerHTML = '<p class="zxt-ort__zeit"><strong>' + esc(b.dataset.ort) + '</strong> → ' + esc(ZXT_ORT) + ': <b>ca. ' + m + ' Min.</b></p><p>' + spruch + '</p>' + (b.dataset.weg ? '<p class="zxa__klein">' + esc(b.dataset.weg) + '</p>' : '') +
        (route ? '<a class="zxa__btn zxa__btn--rand" href="' + route + '" target="_blank" rel="noopener">Route ab ' + esc(b.dataset.ort) + ' →</a>' : '');
    });
  }

  /* ============================================================
     14 · STICK-PLAN-LEISTE (mitlaufender Fortschritt)
     ============================================================ */
  function stickplan(root) {
    function zustand() {
      var p = speicher(PLAN_KEY) || {}, d = speicher('zx-abgabeschein') || {}, zeilen = (d.zeilen || []).filter(function (x) { return x.art; });
      var teile = zeilen.reduce(function (s, x) { return s + Math.max(1, parseInt(x.anzahl, 10) || 1); }, 0);
      var st = { studio: !!p.studio || zeilen.length > 0, schein: zeilen.length > 0, ticket: !!d.ticket };
      ['studio', 'schein', 'ticket'].forEach(function (k) { var li = $('[data-plan-schritt="' + k + '"]', root); if (li) li.classList.toggle('is-fertig', st[k]); });
      var w = $('[data-plan-weiter]', root);
      if (!st.studio) { w.href = '#studio'; w.textContent = 'Ausprobieren →'; }
      else if (!st.schein) { w.href = '#abgabe'; w.textContent = 'Abgabeschein ausfüllen →'; }
      else if (!st.ticket) { w.href = '#abgabe'; w.textContent = 'Ticket erstellen · ' + teile + ' Teile →'; }
      else { w.href = '#abgabestelle'; w.textContent = d.ticket + ' · Zur Abgabestelle →'; }
    }
    var formular = document.getElementById('anfrage'), sichtbarForm = false;
    function zeigen() { root.hidden = window.scrollY < 500 || sichtbarForm; }
    if (formular && 'IntersectionObserver' in window) new IntersectionObserver(function (e) { sichtbarForm = e[0].isIntersecting; zeigen(); }).observe(formular);
    window.addEventListener('scroll', zeigen, { passive: true });
    document.addEventListener('zx-plan-update', zustand);
    document.addEventListener('zx-abgabe-update', zustand);
    zustand(); zeigen();
  }

  /* ============================================================
     15 · AUFTRAGSSTATUS (Metaobjekt "Auftrag") – Darstellung + Suche
     ============================================================ */
  var STATI = [
    { key: 'Angenommen', kurz: 'Annahme', titel: 'Wir haben deine Teile! 📦', text: 'Alles ist sicher bei uns angekommen und fest eingeplant.' },
    { key: 'Design & Freigabe', kurz: 'Design', titel: 'Dein Motiv nimmt Form an ✏️', text: 'Wir bereiten die Stickdatei vor. Falls nötig, schicken wir dir vorher eine Vorschau zur Freigabe.' },
    { key: 'Wird gestickt', kurz: 'Sticken', titel: 'Die Nadeln fliegen 🪡', text: 'Deine Teile sind gerade an der Stickmaschine – Stich für Stich.' },
    { key: 'Qualitätskontrolle', kurz: 'Kontrolle', titel: 'Feinschliff ✨', text: 'Fäden schneiden, Vlies entfernen, jedes Teil prüfen und sorgfältig falten.' },
    { key: 'Abholbereit', kurz: 'Abholen', titel: 'Fertig – abholbereit! 🎉', text: 'Deine Teile warten auf dich.' },
    { key: 'Abgeholt', kurz: 'Abgeholt', titel: 'Abgeholt – viel Freude damit! 💛', text: 'Danke, dass du bei uns sticken lässt.' }
  ];
  function konfetti(ziel) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var farben = ['#ebdcbb', '#a98467', '#e4708f', '#1e6b72', '#f2f2ee', '#b98bae'], box = document.createElement('div');
    box.className = 'zxau__konfetti'; box.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 70; i++) {
      var s = document.createElement('i');
      s.style.cssText = 'left:' + (Math.random() * 100) + '%;background:' + farben[i % farben.length] + ';animation-delay:' + (Math.random() * 0.6) + 's;animation-duration:' + (1.6 + Math.random() * 1.4) + 's;transform:rotate(' + (Math.random() * 360) + 'deg)';
      box.appendChild(s);
    }
    ziel.appendChild(box); setTimeout(function () { box.remove(); }, 3600);
  }
  function auftragRendern(ausgabe, a) {
    var idx = Math.max(0, STATI.map(function (s) { return s.key; }).indexOf(a.status));
    var st = STATI[idx], fertig = a.fertig ? ausIso(a.fertig) : null;
    var schritte = STATI.slice(0, 5);
    var prozent = Math.round(Math.min(idx, 4) / 4 * 100);
    var gestickt = '';
    if (st.key === 'Wird gestickt' && a.teile > 0) {
      var p = Math.min(100, Math.round((a.gestickt || 0) / a.teile * 100));
      gestickt = '<div class="zxau__menge"><div class="zxau__menge-kopf"><span>' + (a.gestickt || 0) + ' von ' + a.teile + ' Teilen gestickt</span><b>' + p + ' %</b></div><div class="zxt__balken"><i style="width:' + p + '%"></i></div></div>';
    }
    var extra = '';
    if (st.key === 'Abholbereit') extra = '<p class="zxau__abholen">📍 Abholung bei <strong>' + esc(a.stelle || 'unserer Abgabestelle') + '</strong> – einfach deine Nummer <b>' + esc(a.nummer) + '</b> nennen.</p>';
    if (st.key === 'Abgeholt') extra = '<div class="zxa__hero-aktionen"><a class="zxa__btn zxa__btn--hell" href="/pages/referenzen#anfrage">Zeig uns dein Projekt →</a><a class="zxa__btn zxa__btn--glas" href="/pages/stickservice">Nächsten Auftrag planen</a></div>';
    ausgabe.innerHTML = '<div class="zxau is-' + idx + (st.key === 'Abholbereit' ? ' is-fertig' : '') + '">' +
      '<div class="zxau__kopf"><div><p class="zxau__nr">Auftrag ' + esc(a.nummer) + '</p><h3 class="zxau__titel">' + st.titel + '</h3><p class="zxau__text">' + st.text + '</p></div>' +
      (st.key === 'Wird gestickt' ? '<div class="zxau__nadel" aria-hidden="true"><svg viewBox="0 0 80 80"><path class="zxau__faden" d="M8 64 C20 40 34 70 46 46 S64 40 72 20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="6 6"/><g class="zxau__nadel-g"><path d="M40 6 L44 46 L40 54 L36 46 Z" fill="#f2f2ee"/><ellipse cx="40" cy="14" rx="1.6" ry="4" fill="#161210"/></g></svg></div>' : '') +
      '</div>' +
      '<ol class="zxau__schritte" role="list" style="--fortschritt:' + prozent + '%">' + schritte.map(function (s, i) {
        var cls = i < idx || idx === 5 ? 'is-erledigt' : i === idx ? 'is-aktuell' : '';
        return '<li class="' + cls + '"' + (i === idx ? ' aria-current="step"' : '') + '><i>' + (i < idx || idx === 5 ? '✓' : i + 1) + '</i><span>' + s.kurz + '</span></li>';
      }).join('') + '</ol>' + gestickt +
      (fertig && idx < 4 ? '<p class="zxau__eta">Voraussichtlich abholbereit: <strong>' + datumLang.format(fertig) + '</strong></p>' : '') +
      (a.notiz ? '<blockquote class="zxau__notiz"><span>Notiz von ' + esc(ZXT_SHOP) + '</span>' + esc(a.notiz).replace(/\n/g, '<br>') + '</blockquote>' : '') +
      extra +
      (a.link ? '<div class="zxau__teilen"><button type="button" class="zxa__btn zxa__btn--glas" data-auftrag-teilen data-link="' + esc(a.link) + '">Link speichern / teilen</button></div>' : '') +
      '</div>';
    if (st.key === 'Abholbereit') konfetti(ausgabe.firstChild);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-auftrag-teilen]'); if (!b) return;
    var link = b.dataset.link, titel = 'Mein Auftrag bei ' + ZXT_SHOP;
    if (navigator.share) { navigator.share({ title: titel, url: link }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(link).then(function () { b.textContent = 'Link kopiert ✓'; });
  });
  function auftrag(root) {
    var daten = json($('[data-auftrag-daten]', root)); if (!daten) return;
    auftragRendern($('[data-auftrag-ausgabe]', root), daten);
    try { localStorage.setItem('zx-auftrag-nr', daten.nummer); } catch (e) {}
  }
  function status(root) {
    var form = $('[data-status-form]', root), feld = $('[data-status-eingabe]', root), aus = $('[data-auftrag-ausgabe]', root);
    var basis = (root.dataset.basis || '/pages/auftrag/');
    function pruefen(nr) {
      nr = (nr || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (!nr) return;
      feld.value = nr;
      aus.innerHTML = '<p class="zxt__leer zxau__laden">Wir schauen nach … 🔍</p>';
      // Shopify macht aus ZA2740 den Handle "za-2740" – beide Schreibweisen probieren
      var klein = nr.toLowerCase(), varianten = [klein.replace(/([a-z])(\d)/g, '$1-$2'), klein];
      function holen(i) {
        if (i >= varianten.length) return Promise.reject(new Error('404'));
        return fetch(basis + varianten[i], { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : holen(i + 1); });
      }
      holen(0).then(function (html) {
        var m = html.match(/<script type="application\/json" data-auftrag-daten>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('keine Daten');
        auftragRendern(aus, JSON.parse(m[1]));
        try { localStorage.setItem('zx-auftrag-nr', nr); } catch (e) {}
      }).catch(function () {
        aus.innerHTML = '<p class="zxt__status is-warn">Zu <strong>' + esc(nr) + '</strong> haben wir noch nichts gefunden. Prüf die Schreibweise (z. B. ZA2740). Gerade erst abgegeben? Dann tragen wir deinen Auftrag in Kürze ein.</p>';
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); pruefen(feld.value); });
    var ausUrl = new URLSearchParams(location.search).get('auftrag');
    var gemerkt = null; try { gemerkt = localStorage.getItem('zx-auftrag-nr'); } catch (e) {}
    if (ausUrl) { pruefen(ausUrl); root.scrollIntoView({ block: 'center' }); }
    else if (gemerkt) feld.value = gemerkt;
  }

  var START = { 'auftrag': auftrag, 'status': status, 'stickstudio': stickstudio, 'abgabestelle': abgabestelle, 'stickplan': stickplan, 'abgabe': abgabe, 'galerie': galerie, 'entscheidung': entscheidung, 'logo-check': logoCheck, 'lieferzeit': lieferzeit, 'preisrechner': preisrechner, 'positionen': positionen, 'garn-kontrast': garnKontrast, 'sammelbestellung': sammelbestellung, 'faq': faq, 'ideen': ideen };
  function init(scope) {
    $$('[data-zxt]', scope).forEach(function (el) {
      if (el.dataset.zxtBereit) return;
      var fn = START[el.dataset.zxt]; if (!fn) return;
      el.dataset.zxtBereit = '1';
      try { fn(el); } catch (e) { if (window.console) console.error('[zx-atelier-tools]', el.dataset.zxt, e); }
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { init(); }) : init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
